import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../helpers/api_helper';
import { MatchingBonusState, MatchingBonusType } from './types';
import { toast } from 'react-toastify';

export const getMatchingBonus = createAsyncThunk(
  'getMatchingBonus/fetch',
  async (id: number | null) => {
    const response = await axiosInstance.get(`/bonus/matching/${id}`);
    if (response.data.data.userPackage === null) {
      toast.error('Please type valid Order ID');
    }
    return response.data.data as MatchingBonusType;
  }
);

const initialState = {
  data: {},
  loading: false
} as MatchingBonusState;

const getMatchingBonusSlice = createSlice({
  name: 'getMatchingBonus',
  initialState,
  reducers: {
    // fill in primary logic here
  },
  extraReducers: (builder) => {
    builder.addCase(getMatchingBonus.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getMatchingBonus.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.data = payload;
    });
    builder.addCase(getMatchingBonus.rejected, (state) => {
      state.loading = false;
    });
  }
});

export default getMatchingBonusSlice.reducer;
